import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import ErpTemplate from '../../../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch } from 'react-icons/fa';
import api from '../../../../services/api';
import '../../../../css/financeiro-parcela-pagar.css';

export default function PainelEventoChecklistAtividade() {
    const token = localStorage.getItem('token');
    const [filtro, setFiltro] = useState({});
    const [buscando, setBuscando] = useState(false);
    const [eventoChecklistAtividades, setEventoChecklistAtividades] = useState([]);

    const [selectedIds, setSelectedIds] = useState(new Set());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);

    const toggleSelect = id => setSelectedIds(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
    const toggleAll = () => paginados.length > 0 && selectedIds.size === paginados.length ? setSelectedIds(new Set()) : setSelectedIds(new Set(paginados.map(r => r.id)));
    const total = eventoChecklistAtividades.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = eventoChecklistAtividades.slice((page - 1) * pageSize, page * pageSize);
    const selectedArr = [...selectedIds];

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setBuscando(true);
        api({
            method: 'get',
            action: '/eventoChecklistAtividade',
            token: token,
            params: filtro,
            signal: controllerRef.current.signal
        })
            .then(response => {
                setEventoChecklistAtividades(response.data.data);
                setBuscando(false);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                setBuscando(false);
            });
    };

    useEffect(() => {
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    useEffect(() => {
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        [filtro.nome]);

    const getPrazoLabel = (row) => {
        var textoPrazo = "";
        if (row.prazo !== undefined) {
            if (row.prazo < 1) {
                textoPrazo += (row.prazo * -1) + " dias antes o evento";
            } else {
                textoPrazo += row.prazo + " dias depois do evento";
            }
        }
        return textoPrazo;
    };

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Atividades de Checklist</h1></div>
                    <div className="fin-pp__actions">
                        <Link to="/cadastroEventoChecklistAtividade" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill"><FaPlus size={14} /> Nova Atividade</Link>
                    </div>
                </div>

                <form className="fin-pp__card fin-pp__search" style={{ marginBottom: 16, padding: '12px 16px' }} onSubmit={e => { buscar(); e.preventDefault(); }}>
                    <div className="fin-pp__search-field">
                        <FaSearch className="fin-pp__search-ic" size={16} />
                        <input
                            className="fin-pp__input"
                            type="text"
                            placeholder="Buscar pelo nome da atividade"
                            onChange={e => setFiltro({ ...filtro, ...{ "nome": e.target.value } })}
                        />
                    </div>
                    <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={buscando}>
                        {buscando ? 'Buscando...' : 'Buscar'}
                    </button>
                </form>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead><tr>
                                <th style={{ width: 40 }}><input type="checkbox" checked={paginados.length > 0 && selectedIds.size === paginados.length} onChange={toggleAll} /></th>
                                <th style={{ width: 60 }}></th>
                                <th style={{ width: 80 }}>Código</th>
                                <th style={{ width: 80 }}>Ordem</th>
                                <th>Superior</th>
                                <th>Nome</th>
                                <th>Requisito</th>
                                <th>Prazo</th>
                            </tr></thead>
                            <tbody>
                                {buscando ? <tr><td colSpan={8} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                    : paginados.length === 0 ? <tr><td colSpan={8} className="fin-pp__empty">Nenhum registro</td></tr>
                                        : paginados.map(row => (
                                            <tr key={row.id}>
                                                <td><input type="checkbox" checked={selectedIds.has(row.id)} onChange={() => toggleSelect(row.id)} /></td>
                                                <td><Link to={"/cadastroEventoChecklistAtividade/" + row.id} className="fin-pp__rowbtn"><FaPen size={14} /></Link></td>
                                                <td style={{ textAlign: 'right' }}>{row.codigo ?? ""}</td>
                                                <td style={{ textAlign: 'right' }}>{row.ordem ?? ""}</td>
                                                <td>{row.superior?.nome ?? ""}</td>
                                                <td className="fin-pp__cell-strong">{row.nome ?? ""}</td>
                                                <td>{row.requisito?.nome ?? ""}</td>
                                                <td>{getPrazoLabel(row)}</td>
                                            </tr>
                                        ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select className="fin-pp__select" style={{ height: 34 }} value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}>
                                <option value={15}>15 / pág</option><option value={30}>30 / pág</option><option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
